import { call, put, takeLatest } from 'redux-saga/effects';

import * as timerActions from './timerActions.js';
import { updateTimerApiCall } from './timerAPI.js';

function* updateTimerSaga({ payload }) {
  try {
    const { data } = yield call(updateTimerApiCall, payload);
    yield put(timerActions.timerUpdateStore(data));
  } catch (error) {
    yield put(timerActions.timerUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* timerWatcher() {
  yield takeLatest(timerActions.timerUpdateRequest.type, updateTimerSaga);
}
